import { useQuery } from "@apollo/client";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { isCamkitEnabledInAnyOrg } from "../../core/context";
import { CofConfigId } from "../../gql-generated/types";
import { type GetOrganizationsQuery, getOrganizations } from "../../shared/api/queries";
import { type ApolloResult } from "../../shared/models";

export const useCamkitEnabled = (): ApolloResult<{ data: boolean }> => {
    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;

    // V1: check cameraKitEnabled field in organizations
    const { data: v1Data, loading: v1Loading } = useQuery<GetOrganizationsQuery>(getOrganizations, {
        skip: isMyLensesOrgsV2Enabled,
    });

    // V2: show APIs to everyone
    if (isMyLensesOrgsV2Enabled) {
        return { data: true, loading: false };
    }

    const isCamkitEnabledV1 =
        !!v1Data?.getMyLensesOrganizations.organizationsList &&
        isCamkitEnabledInAnyOrg(v1Data.getMyLensesOrganizations.organizationsList);

    return {
        data: isCamkitEnabledV1,
        loading: v1Loading,
    };
};
